<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="prologue">
<h1>Prologue</h1>
<p style="text-align: center;">The need to educate our children about life skills and being kind to others is essential, both at home and at school.</p><br/>
<p style="text-align: center;">This book is aimed at Key Stage 1 school children. It is not a text book. It is a series of short stories aimed at promoting discussion and guidance, perhaps best used in PSHCE and assemblies.</p><br/>
<p style="text-align: center;">We need to do all we can to create kind children who are better equipped to deal with diﬃcult situations.</p>
<p><br/>
</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?2efb47fe